import React, {Component, Fragment} from 'react';
import {Col, Nav, Row} from 'reactstrap';
import NavTab from './NavTab.js';

class TabNavs extends Component {
	render() {
		switch (this.props.section) {
		case 'PROGRAM':
			return (
				<Row>
					<Col xs={9}>
						<Nav>
							<NavTab
								subsection={this.props.subsection}
								changeSubsection={this.props.changeSubsection}
								tabSection="MAIN"
								tabTitle="FEATURES"
							/>
							<NavTab
								subsection={this.props.subsection}
								changeSubsection={this.props.changeSubsection}
								tabSection="CONTENT"
								tabTitle="CONTENT"
							/>
							<NavTab
								subsection={this.props.subsection}
								changeSubsection={this.props.changeSubsection}
								tabSection="MODIFICATIONS"
								tabTitle="MODIFICATIONS"
							/>
						</Nav>
					</Col>
				</Row>
			);

		case 'HARDWARE':
			return (
				<Row className="hardwareTitle">
					<Col xs={12} className="mb-3">
						<h2 className="h2 mb-3">{this.props.title}</h2>
					</Col>
					<Col xs={9} className="ml-3">
						<Nav className="mb-2">
							<NavTab
								id="HW-SPECIFICATIONS"
								subsection={this.props.subsection}
								changeSubsection={this.props.changeSubsection}
								tabSection="MAIN"
								tabTitle="SPECIFICATIONS"
							/>
							<NavTab
								id="HW-NEW-ORDERS"
								subsection={this.props.subsection}
								changeSubsection={this.props.changeSubsection}
								tabSection="NEW_ORDERS"
								tabTitle="NEW ORDERS"
							/>
							<NavTab
								id="HW-SERVICE-CALLS"
								subsection={this.props.subsection}
								changeSubsection={this.props.changeSubsection}
								tabSection="SERVICE_CALLS"
								tabTitle="SERVICE CALLS"
							/>
							<NavTab
								id="HW-POS"
								subsection={this.props.subsection}
								changeSubsection={this.props.changeSubsection}
								tabSection="POS"
								tabTitle="PO's"
							/>
						</Nav>
					</Col>
				</Row>
			);

		case 'SPLASH':
		default:
			return <div />;
		}
	}
}

export default TabNavs;



// WEBPACK FOOTER //
// ./src/components/TabNavs.js